import {Component, OnDestroy, OnInit} from "@angular/core";
import {LookupService} from "../../lookup.service";

@Component({
  selector: "admin-lookup-common-share",
  templateUrl: "./share.component.html",
  styleUrls: ["./share.component.css"]
})
export class AdminLookupCommonShareComponent implements OnInit, OnDestroy {

  constructor(
    private singleService: LookupService,
  ) {
    console.log("- SHARE 'LOOKUP' CONSTRUCTOR -");
  }

  ngOnInit(): void {
    console.log("- SHARE 'LOOKUP' INITIALIZING -");
  }

  ngOnDestroy(): void {
    console.log("- SHARE 'LOOKUP' DESTROYING -");
    this.singleService.initState();
  }

}
